/**
 * @file Counts down `Lifetime` components and destroys expired entities.
 */

import { System } from '../ecs/System.js';
import { Lifetime } from '../components/index.js';

export class LifetimeSystem extends System {
  static priority = 60;

  /**
   * @param {number} dt Delta time in seconds.
   * @returns {void}
   */
  update(dt) {
    for (const entity of this.world.query(Lifetime)) {
      const lifetime = entity.get(Lifetime);
      lifetime.remaining -= dt;
      if (lifetime.remaining <= 0) this.world.destroyEntity(entity);
    }
  }
}
